module.exports = "/desktop-app/assets/img/caution.png?fedfb7515465a909538bdfd44a0455f0";


//////////////////
// WEBPACK FOOTER
// ./foody/src/assets/common/images/icon/caution.png
// module id = b8jN
// module chunks = 1